export const FILESPACE_V7 = 7;
export const FILESPACE_V8 = 8;
export const FILESPACE_V9 = 9;
export const FILESPACE_V10 = 10;
export const FILESPACE_V12 = 12;
// Event stream support, in development. WebFs links V13 to consume the event stream (LucidAPI
// listEvents) but does not run the replication log yet: its own writes coalesce, so intermediate
// revisions produce no events.
export const FILESPACE_V13 = 13;
export const MIN_SUPPORTED_FS_VERSION = FILESPACE_V7;
export const MAX_SUPPORTED_FS_VERSION = FILESPACE_V13;
